/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const TreatmentListHeader = ({
  reloadTreatments,
  changeStatusHandler
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const location = useLocation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    {
      title: t("Clinical Management"),
      link: "/admin/clinicalmanagement/treatments",
    },
    { title: t("Treatment") },
  ];

  // Precise view detection (avoid substring collisions)
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const isListView = normalizedPath === "/admin/clinicalmanagement/treatments";
  const isCalendarView = normalizedPath === "/admin/clinicalmanagement/treatmentscalendar";
  const isKanbanView = normalizedPath === "/admin/clinicalmanagement/treatmentskanban";

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="d-flex align-items-center gap-2 ps-1 flex-wrap">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
          {/* View Toggle Buttons now on the left */}
          <div className="btn-group ms-3" role="group" aria-label="View toggle">
            <Link
              to="/admin/clinicalmanagement/treatments"
              className={`btn btn-outline-primary d-flex align-items-center px-3 py-2 ${isListView ? 'active' : ''}`}
              title={t("List View")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                list
              </span>
              <span className="fw-semibold small">{t("List View")}</span>
            </Link>
            <Link
              to="/admin/clinicalmanagement/treatmentscalendar"
              className={`btn btn-outline-primary d-flex align-items-center px-3 py-2 ${isCalendarView ? 'active' : ''}`}
              title={t("Calendar View")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                calendar_month
              </span>
              <span className="fw-semibold small">{t("Calendar View")}</span>
            </Link>
            <Link
              to="/admin/clinicalmanagement/treatmentskanban"
              className={`btn btn-outline-primary d-flex align-items-center px-3 py-2 ${isKanbanView ? 'active' : ''}`}
              title={t("Kanban View")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                view_kanban
              </span>
              <span className="fw-semibold small">{t("Kanban View")}</span>
            </Link>
          </div>
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* Removed view toggle from here */}
          <Link
            onClick={reloadTreatments}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          { isListView && (
            <div className="dropdown">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#addLabelModal"
                  >
                    <span className="material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span>{t("Add Label")}</span>
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    onClick={changeStatusHandler}
                  >
                    <span className="material-symbols-outlined icon-sm text-danger">
                      delete
                    </span>
                    <span>{t("Delete")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          )}
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#templateAdvFilter"
            aria-controls="templateAdvFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
          {!isKanbanView && (
          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveTreatmentTemplateOffCanvas"
            aria-controls="saveTreatmentTemplateOffCanvas"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
          )}
        </div>
      </div>
    </div>
  );
};
export default TreatmentListHeader;
